import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconLogout } from 'library/styles/icon';

export const Container = styled.div`
  background: ${Colors.shade08};
  margin-top: 45px;
  max-width: 800px;
  min-width: 320px;
  padding: 32px 40px;
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 4px;
  position: relative;
`;

export const Title = styled.h1`
  font-weight: bold;
  font-size: 32px;
  color: ${Colors.shade01};
  margin: 0;    
`;

export const UserInfo = styled.p`
  font-size: 18px;
  color: ${Colors.shade02};
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.shade09};
  margin: 20px 75px 0 0;
`;

export const LogoutText = styled.p`
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  display: none;
  align-items: center;
  color: ${Colors.shade01};
  margin: 0 4px;
`;

export const Icon = styled(IconLogout)``;

export const LogoutContainer = styled.div`
  display: flex;
  width: 50px;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  top: 27px;
  right: 45px;
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.2);
  border-radius: 40px;
  height: 50px;
  align-items: center;
  background: ${Colors.shade08};
  cursor: pointer;
  transition: 0.4s;

  &:hover ${LogoutText} {
    display: flex;
  }

  &:hover ${Icon} {
    display: flex;
    margin-left: 0;
  }

  &:hover {
    right: -20px;
    padding-left: 18px;
    padding-right: 8px;
    width: auto;
  }
`;

export const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
